import { ArrowRight, CheckCircle2, Lightbulb } from "lucide-react";

export default function HelpArticle({ article, labels, compact = false }) {
  if (!article) return null;
  return (
    <article className="space-y-5" data-testid={`help-article-${article.id}`}>
      <div>
        <h2 className={`${compact ? "text-xl" : "text-2xl"} font-heading font-bold tracking-tight`}>
          {article.title}
        </h2>
        <p className="mt-1 text-sm leading-6 text-muted-foreground">{article.summary}</p>
      </div>

      <section aria-labelledby={`help-steps-${article.id}`}>
        <h3 id={`help-steps-${article.id}`} className="mb-3 flex items-center gap-2 text-sm font-semibold">
          <CheckCircle2 className="h-4 w-4 text-emerald-600" />
          {labels.steps}
        </h3>
        <ol className="space-y-3">
          {article.steps.map((step, index) => (
            <li key={step} className="flex gap-3 text-sm leading-6">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
                {index + 1}
              </span>
              <span className="pt-px">{step}</span>
            </li>
          ))}
        </ol>
      </section>

      {article.tips?.length > 0 && (
        <section className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-950 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-100">
          <h3 className="mb-2 flex items-center gap-2 text-sm font-semibold">
            <Lightbulb className="h-4 w-4" />
            {labels.tips}
          </h3>
          <ul className="space-y-1.5 text-sm leading-5">
            {article.tips.map((tip) => <li key={tip}>• {tip}</li>)}
          </ul>
        </section>
      )}

      {article.next && (
        <section className="flex gap-3 rounded-xl border bg-muted/40 p-4">
          <ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
          <div>
            <h3 className="text-sm font-semibold">{labels.next}</h3>
            <p className="mt-1 text-sm leading-5 text-muted-foreground">{article.next}</p>
          </div>
        </section>
      )}
    </article>
  );
}
